export var SORTABLE_COLUMN_ICON_CLASSNAME = "ak-renderer-tableHeader-sorting-icon";